import React, { useEffect, useRef, useState } from "react";
// import SideMenu from "../sideMenu/sideMenu";
import Menu from "../menu/menu";
import Section from "../section/section";
import { fetchContents } from "../../redux/actions";
import { connect, useDispatch } from "react-redux";
import useApiDataWithTabVisibility from "../../useApiDataWithTabVisibility";
import Redirect from "../../pages/redirect/redirect";
import "./layout.scss"
import { cleanOldImages } from "../../utils/getImageAsBase64";

function Layout(props) {

    const { user } = props;

    const _baseClass = "layout";
    // const [collapsed, toggleCollapse] = useState(true);
    const [isOpen, setOpen] = useState(false);

    const dispatch = useDispatch()
    const userRef = useRef(user);

    // Always keep the latest user in the ref
    useEffect(() => {
        userRef.current = user;
    }, [user]);

    useEffect(() => {
        cleanOldImages();
    }, []);

    useApiDataWithTabVisibility(() => {
        const currentUser = userRef.current;
        if (currentUser?.isLogged) {
            dispatch(fetchContents());
        }
    }, user);

    if (!user.isLogged) {
        return <Redirect />
    }

    return (
        <div className={_baseClass + " bg-[#FAFAFA] sm:bg-[#F4F5F6] h-full"}>
            {/* <SideMenu collapsed={collapsed} toggleCollapse={toggleCollapse} /> */}
            <Menu setOpen={setOpen} isOpen={isOpen} />
            <Section isOpen={isOpen} />
        </div>
    );
}

const mapStateToProps = state => ({
    user: state.user
});

export default connect(mapStateToProps)(Layout)